export const WALLET_TYPES = {
	google_pay: 'Google Pay',
	apple_pay: 'Apple Pay',
	paypal: 'PayPal',
	swish: 'Swish',
	multibanco: 'Multibanco',
	twint: 'TWINT',
	ideal: 'Ideal',
};
